<template>
    <v-textarea
        @input="$emit('input', $event)"
        :value="value"
        :label="label"
        class="pa-4"
        auto-grow
        outlined
        :rules="noteRules"
        ref="textarea"
        @update:error="validate($event)"
        :autofocus="autofocus"
    ></v-textarea>
</template>

<script>
export default {
    props: {
        value: {},
        autofocus: {
            type: Boolean,
            default: false,
        },
        lessonType: {
            type: Object,
            default: () => {
                assessment: true;
            },
        },
    },
    computed: {
        required() {
            return !this.lessonType.hold;
        },
        noteRules() {
            if (!this.required) {
                return [];
            }
            return [
                (v) =>
                    !!v || "You must provide information about this student!",
                (v) => (v || "").length <= 510 || "Character limit reached",
                (v) =>
                    (v && !!v.trim()) ||
                    "You must provide details about this lesson!",
            ];
        },
        label() {
            return this.lessonType.hold
                ? "Reason for hold..."
                : "Experience, interests, goals...";
        },
    },
    methods: {
        validate(valid) {
            // why is this backwards??
            this.$emit("valid", valid);
        },
    },
    mounted() {
        this.$emit("mounted");
        this.validate(this.required ? !this.value?.length > 0 : false);
    },
};
</script>

<style></style>
